import { render, staticRenderFns } from "./ScanIn10.vue?vue&type=template&id=2dcb0f90&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./ScanIn10.vue?vue&type=script&lang=js"
export * from "./ScanIn10.vue?vue&type=script&lang=js"
import style0 from "./ScanIn10.vue?vue&type=style&index=0&id=2dcb0f90&prod&lang=scss&scoped=true"
import style1 from "./ScanIn10.vue?vue&type=style&index=1&id=2dcb0f90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcb0f90",
  null
  
)

export default component.exports